import { JSX, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Button,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    TableFooter
} from '@mui/material';
import {
    Close as CloseIcon ,
    AddCircleOutline,
    Add as AddIcon,
    ChevronLeft,
    ChevronRight,
    Edit as EditIcon,

} from '@mui/icons-material';
import { useGetList } from 'react-admin';
import { Coupon } from "../../../../../types/entities";
import { couponTypes } from "../../../../../defaults/defaults";

export const SubscriptionManagerDiscountPanelModal: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [activePage, setActivePage] = useState<number>(1);
    const activeDiscounts: string[] = props.activeDiscounts;
    const { data, total, isPending, error } = useGetList(
        'coupons',
        {
            pagination: { page: activePage, perPage: 10 },
            sort: { field: 'published_at', order: 'DESC' }
        }
    );

    function handleCloseModal(): void {
        setOpenModal(false);
    }

    function handleOpenModal(): void {
        setOpenModal(true);
    }

    function handleNextPage(): void {
        const newPage: number = activePage + 1;
        if (newPage < (total % 10)) {
            setActivePage(newPage);
        }
    }

    function handlePreviousPage(): void {
        const newPage: number = activePage - 1;
        if (newPage > 0) {
            setActivePage(newPage);
        }
    }

    function convertDiscountType(type: string): string {
        let returnType: string = "";
        for(const t of couponTypes) {
            if (t.id === type) {
                returnType = t.name
            }
        }
        return returnType;
    }

    function handleAddDiscount(id: string): void {
        props.handleDiscountChange(id, 'add')
    }

    function handleRemoveDiscount(id: string): void {
        props.handleDiscountChange(id, 'minus')
    }

    return (
        <>
            <Button variant="contained"
                    onClick={ handleOpenModal }
                    title="Coupons"
                    type="button">
                <EditIcon />
            </Button>
            <Dialog open={ openModal }
                    onClose={ handleCloseModal }
                    fullWidth
                    className="subscription__discount-modal"
                    maxWidth="md">
                <DialogTitle>
                    <div style={ { width: '100%', display: 'flex', justifyContent: 'space-between' } }>
                        <span style={ { fontSize: '1.3rem', fontWeight: 'bold' }} >{ "Coupons" }</span>
                        <button type="button"
                                onClick={ handleCloseModal }
                                style={ { cursor: 'pointer' } }>
                            <CloseIcon />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent >
                    <div className="discount-modal__content">
                        <Table sx={ { width: '100%' } }>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{ "Id" }</TableCell>
                                    <TableCell>{ "Name" }</TableCell>
                                    <TableCell>{ "Code" }</TableCell>
                                    <TableCell>{ "Amount Off" }</TableCell>
                                    <TableCell>{ "Type" }</TableCell>
                                    <TableCell align="right">{ "Add/Remove" }</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { data?.map((coupon: Coupon, index: number): JSX.Element => {
                                    const couponId: string = coupon.id.toString();

                                    return (
                                        <TableRow key={ "coupon_table_row_" + index }>
                                            <TableCell>{ coupon.id }</TableCell>
                                            <TableCell>{ coupon.name }</TableCell>
                                            <TableCell>{ coupon.code }</TableCell>
                                            <TableCell>{ parseFloat(coupon.amountOff).toFixed(2) }</TableCell>
                                            <TableCell>{ convertDiscountType(coupon.discountType) }</TableCell>
                                            <TableCell align="right">
                                                { (!activeDiscounts.includes(couponId)) &&
                                                    <Button
                                                        disabled={ (activeDiscounts.length > 0) }
                                                        variant="contained"
                                                        color="success"
                                                        onClick={ (): void => handleAddDiscount(couponId) } >
                                                        <AddIcon />
                                                    </Button>
                                                }
                                                { (activeDiscounts.includes(couponId)) &&
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        onClick={ (): void => handleRemoveDiscount(couponId) }>
                                                        <CloseIcon />
                                                    </Button>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    );
                                } ) }
                            </TableBody>
                        </Table>
                        <div className="content__pagination">
                            <Button type="button"
                                    variant="contained"
                                    onClick={ handlePreviousPage }
                                    disabled={ (total < 10) }
                            >
                                <ChevronLeft />
                            </Button>
                            <span style={ {
                                margin: '0 10px 0 10px',
                            } } >{ activePage + '/' + ( total % 10 ) }</span>
                            <Button type="button"
                                    variant="contained"
                                    onClick={ handleNextPage }
                                    disabled={ (total < 10) }
                            >
                                <ChevronRight />
                            </Button>

                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}